import {
  FETCH_RFQ_LOADING, FETCH_RFQ_DONE, FETCH_RFQ_ERROR,
  FETCH_RFQ_BY_ID_LOADING, FETCH_RFQ_BY_ID_DONE, FETCH_RFQ_BY_ID_ERROR,
  FETCH_BID_LOADING, FETCH_BID_DONE, FETCH_BID_ERROR,
  FETCH_BID_PRICE_LOADING, FETCH_BID_PRICE_DONE, FETCH_BID_PRICE_ERROR,
  CREATE_RFQ_LOADING, CREATE_RFQ_DONE, CREATE_RFQ_ERROR,
  EXTEND_RFQ_LOADING, EXTEND_RFQ_DONE, EXTEND_RFQ_ERROR,
  CANCEL_RFQ_LOADING, CANCEL_RFQ_DONE, CANCEL_RFQ_ERROR,
  FETCH_RFQ_FILTER_LOADING, FETCH_RFQ_FILTER_DONE, FETCH_RFQ_FILTER_ERROR
} from './actions'

export default {
  [FETCH_RFQ_LOADING] (state) {
    state.isLoading = true
    state.itemExtend = false
  },

  [FETCH_RFQ_DONE] (state, items) {
    state.items = items
    state.isLoading = false
  },

  [FETCH_RFQ_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [FETCH_RFQ_FILTER_LOADING] (state) {
    state.isLoadingRfqFilter = true
  },

  [FETCH_RFQ_FILTER_DONE] (state, items) {
    state.rfqFilter = items
    state.isLoadingRfqFilter = false
  },

  [FETCH_RFQ_FILTER_ERROR] (state, error) {
    state.errorRfqFilter = error
    state.isLoadingRfqFilter = false
  },

  [FETCH_RFQ_BY_ID_LOADING] (state) {
    state.isLoading = true
    state.error = false
  },

  [FETCH_RFQ_BY_ID_DONE] (state, items) {
    state.item = items
    state.isLoading = false
    state.error = false
  },

  [FETCH_RFQ_BY_ID_ERROR] (state, error) {
    state.error = true
    state.isLoading = false
  },

  [FETCH_BID_LOADING] (state) {
    state.isLoadingBid = true
    state.isErrorLoadingBid = false
  },

  [FETCH_BID_DONE] (state, items) {
    state.bids = items
    state.isLoadingBid = false
    state.isErrorLoadingBid = false
  },

  [FETCH_BID_ERROR] (state, error) {
    state.isErrorLoadingBid = true
    state.isLoadingBid = false
  },

  [FETCH_BID_PRICE_LOADING] (state) {
    state.isLoadingBidPrice = true
    state.isErrorLoadingBidPrice = false
  },

  [FETCH_BID_PRICE_DONE] (state, items) {
    state.bidPrice = items
    state.isLoadingBidPrice = false
    state.isErrorLoadingBidPrice = false
  },

  [FETCH_BID_PRICE_ERROR] (state, error) {
    state.isErrorLoadingBidPrice = true
    state.isLoadingBidPrice = false
    state.bidPrice = []
  },

  [CREATE_RFQ_LOADING] (state) {
    state.isLoadingCreated = true
  },

  [CREATE_RFQ_DONE] (state, item) {
    state.created = item
    state.isLoadingCreated = false
  },

  [CREATE_RFQ_ERROR] (state, error) {
    state.error = error.data
    state.isLoadingCreated = false
  },

  [EXTEND_RFQ_LOADING] (state) {
    state.isLoadingExtend = true
  },

  [EXTEND_RFQ_DONE] (state, item) {
    state.itemExtend = item
    state.isLoadingExtend = false
    state.errorExtend = null
  },

  [EXTEND_RFQ_ERROR] (state, error) {
    state.itemExtend = null
    state.errorExtend = error
    state.isLoadingExtend = false
  },

  [CANCEL_RFQ_LOADING] (state) {
    state.isLoadingCancel = true
  },

  [CANCEL_RFQ_DONE] (state, itemCancel) {
    state.itemCancel = itemCancel
    state.isLoadingCancel = false
    state.errorCancel = null
  },

  [CANCEL_RFQ_ERROR] (state, error) {
    state.itemCancel = null
    state.errorCancel = error
    state.isLoadingCancel = false
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/rfq/mutations.js